function InventoryMapWidgetCtrl($scope, WIDGET_DATA_TYPES) {
  $scope.currentSection = 'BASIC';
  $scope.widgetBuilderConfig = {
    toolbar: [{
      visible: false,
      key: 'venueId',
      value: () => {
        return $scope.venue ? $scope.venue.id : null;
      }
    }, {
      name: 'Theme',
      key: 'theme',
      type: WIDGET_DATA_TYPES.SELECT,
      value: 'theme-light',
      selectValues: [{
        key: 'Light Theme',
        value: 'theme-light'
      }, {
        key: 'Dark Theme',
        value: 'theme-dark'
      }]
    }, {
      name: 'Event',
      key: 'date',
      type: WIDGET_DATA_TYPES.EVENT,
      value: null
    }, {
      name: 'Date',
      key: 'date',
      type: WIDGET_DATA_TYPES.DATE,
      value: new Date()
    }]
  };

  //TODO: need to pass the widget builder the 'type' field (TABLE vs. GUESTLIST)

  //code snippets
  $scope.snippet1 = function () {
    return '<div id="inventory-list-map-widget"></div>';
  };

  $scope.snippet2 = function () {
    if (!$scope.venue) return '';

    return `<script>
window.TablelistWidgets.onReady(function() {
  var inventoryListMapWidget = new window.TablelistWidgets.widgets.InventoryListMapWidget('#inventory-list-map-widget'); //accepts either a String used as a CSS Selector, or a DOMNode

  inventoryListMapWidget.init({
    venueId: '${$scope.venue.id}'
  });
});
</script>`;
  };
}

InventoryMapWidgetCtrl.$inject = [
  '$scope',
  'WIDGET_DATA_TYPES'
];

export default InventoryMapWidgetCtrl;



// WEBPACK FOOTER //
// ./src/directives/widgets/inventoryMapWidget/controller.js